<template>
    <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow">
        <div :class="getClass()">
            <div class="container">
                <!-- Header -->
                <div class="header">
                    <SmartLinkStandaloneElement :codename="typ.elements.icon.codename" v-if="data.icon">
                        <font-awesome class="icon fa-fw" :icon="data.icon" />
                    </SmartLinkStandaloneElement>
                    <SmartLinkStandaloneElement :codename="typ.elements.title.codename">
                        <h2 class="title" v-if="data.title">
                            {{ data.title }}
                        </h2>
                    </SmartLinkStandaloneElement>
                </div>
                <!-- Description -->
                <SmartLinkStandaloneElement :codename="typ.elements.description.codename">
                    <div class="description">
                        <RichText :value="data.description" />
                    </div>
                </SmartLinkStandaloneElement>
                <!-- Table -->
                <table class="table">
                    <thead>
                        <tr>
                            <th v-if="data.column1.trim()">
                                <SmartLinkStandaloneElement :codename="typ.elements.column_1.codename">
                                    {{ data.column1.trim() }}
                                </SmartLinkStandaloneElement>
                            </th>
                            <th v-if="data.column2.trim() && hasAnyStatus">
                                <SmartLinkStandaloneElement :codename="typ.elements.column_2.codename">
                                    {{ data.column2.trim() }}
                                </SmartLinkStandaloneElement>
                            </th>
                            <th v-if="data.column3.trim()">
                                <SmartLinkStandaloneElement :codename="typ.elements.column_3.codename">
                                    {{ data.column3.trim() }}
                                </SmartLinkStandaloneElement>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- Action Section -->
                        <ActionSection v-for="sec in data.sections" :model="sec" :has-any-status="hasAnyStatus"/>
                    </tbody>
                </table>
                <!-- Footer Text -->
                <SmartLinkStandaloneElement :codename="typ.elements.footer_text.codename">
                    <div class="footer-text">
                        <RichText :value="data.footerText" />
                    </div>
                </SmartLinkStandaloneElement>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import type { ActionItemModel, ActionSectionModel, ActionTableModel } from '~/models';
import { contentTypes } from '~/models';
const typ = contentTypes.action_table;

const pageStore = usePageStore();
const props = defineProps<{ model: ActionTableModel }>();

const data = {
    title: props.model.elements.title.value,
    description: props.model.elements.description.value,
    icon: props.model.elements.icon.value,
    background: firstOrDefault(props.model.elements.background.value),
    footerText: props.model.elements.footerText.value,
    sections: pageStore.getListAs<ActionSectionModel>(props.model.elements.actionSections.value),
    column1: props.model.elements.column1.value,
    column2: props.model.elements.column2.value,
    column3: props.model.elements.column3.value,
    cssClass: props.model.elements.cssClass.value
}

const hasAnyStatus = computed(() =>
  data.sections.some(section => {
    const sectionStatus = section.elements.status?.value ?? [];
    const rows = pageStore.getListAs<any>(section.elements.actionItems.value ?? []);
    return sectionStatus.some((s: { codename: string }) => s.codename !== 'no_status') ||
           rows.some(row =>
             (row.elements?.status?.value ?? []).some((s: { codename: string }) => s.codename !== 'no_status')
           );
  })
);


function getClass() {
    let result = 'action-table'
    if (data.background?.codename)
        result = `${result} ${backgroundOptions(data.background?.codename)}`;
    else
        result = `${result} light`

    if (data.cssClass) {
        result += ` ${data.cssClass}`;
    }

    return result;

}
</script>
